<template>
  <CustomModal 
    :show="showModal"
    size="lg"
    @closeModal="$emit('close')">
    <template #modal-header>
      Batch Billing
    </template>
    <template #modal-body>
      <div class="batch-billing__form">
        <div class="batch-billing__form-left">
          <b-form-group
            :state="form.states.taxTypeId"
            :invalid-feedback="form.errors.taxTypeId">
            <label class="required">Sales Tax Type</label>
            <v-select
              v-model="form.fields.taxTypeId"
              :options="[{id: null, name: 'ALL'},...options.taxTypes.items]"
              label="name"
              :reduce="item => item.id"
              appendToBody
              :class=" { 'is-invalid' : !!form.errors.taxTypeId  }"
            />
          </b-form-group>
          <b-form-group
            :invalid-feedback="form.errors.businessTypeId"
            :state="form.states.businessTypeId">
            <label class="required">Business Type</label>
            <v-select
              :options="[{id: null, name: 'ALL'},...options.businessTypes.items]"
              label="name"
              :disabled="options.businessTypes.isBusy"
              v-model="form.fields.businessTypeId"
              :reduce="businessType => businessType.id"
              :class=" { 'is-invalid' : !!form.errors.businessTypeId  }"
              :loading="options.businessTypes.isBusy"
            >
              <template #spinner="{ loading }">
                <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner" />
              </template>
            </v-select>
          </b-form-group>
          <b-form-group
            :invalid-feedback="form.errors.businessStyleId"
            :state="form.states.businessTypeId">
            <label class="required">Business Style</label>
            <v-select
              :options="[{id: null, name: 'ALL'},...options.businessStyles.items]"
              label="name"
              :disabled="options.businessStyles.isBusy"
              v-model="form.fields.businessStyleId"
              :reduce="businessStyle => businessStyle.id"
              :class=" { 'is-invalid' : !!form.errors.businessStyleId  }"
              :loading="options.businessStyles.isBusy"
            >
              <template #spinner="{ loading }">
                <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner" />
              </template>
            </v-select>
          </b-form-group>
        </div>
        <div class="batch-billing__form-right">
          <b-form-group>
            <label class="required"> Billing Date</label>
            <b-form-datepicker
              :state="form.states.billingDate"
              v-model="form.fields.billingDate"/>
            <b-form-invalid-feedback>
              {{ form.errors.billingDate }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group>
            <label class="required"> Due Date</label>
            <b-form-datepicker 
              :state="form.states.dueDate"
              v-model="form.fields.dueDate"/>
            <b-form-invalid-feedback>
              {{ form.errors.dueDate }}
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="button-footer">
        <SaveButton @click="$emit('save')" :isProcessing="form.isProcessing" label="Proceed"/>
        <CloseButton @click="$emit('close')" class="ml-2 float-right"  />
      </div>
    </template>
  </CustomModal>
</template>
<script>
import { BusinessStyleApi, BusinessTypeApi, TaxTypeApi } from '../../../mixins/api'
import { 
  CustomModal,
  SaveButton,
  CloseButton } from '../../components'
export default {
  components: {
    CustomModal,
    CloseButton,
    SaveButton
  },
  mixins: [TaxTypeApi, BusinessTypeApi, BusinessStyleApi],
  props: {
    form: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    },
    monthId: Number,
    year: Number,
  },
  data() {
    return {
      options: {
        taxTypes: {
          items: []
        },
        businessTypes: {
          items: []
        },
        businessStyles: {
          items: []
        }
      }
    }
  },
  created() {
    this.loadTaxTypes()
    this.loadBusinessStyles()
    this.loadBusinessTypes()
  },
  methods: {
    loadTaxTypes(){
      const { taxTypes } = this.options
      this.getTaxTypeList({ paginate: false }).then(({ data }) => {
        taxTypes.items = data
      }).catch(error => {
        console.log(error)
      })
    },
    loadBusinessStyles(){
      const { businessStyles } = this.options
      this.getBusinessStyleList({ paginate: false }).then(({ data }) => {
        businessStyles.items = data
      }).catch(error => {
        console.log(error)
      })
    },
    loadBusinessTypes(){
      const { businessTypes } = this.options
      this.getBusinessTypeList({ paginate: false }).then(({ data }) => {
        businessTypes.items = data
      }).catch(error => {
        console.log(error)
      })
    },
  },
  computed: {
    showModal: {
      get: function() {
        return this.show
      },
      set: function(newValue) {
        return newValue
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .batch-billing__form {
    width: 100%;
    display: flex;

    .batch-billing__form-left {
      margin: 5px;
      width: 50%;
    }
    .batch-billing__form-right {
      margin: 5px;
      width: 50%;
    }
  }
</style>